import React from 'react'
import TBCMessage from './TBCMessage'
import TBCBackground from './TBCBackground'

export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      is_active: true,
    }
  }

  nextMessage()
  {
    this.disable()
    this.props.nextMessage();
  }

  disable()
  {
    this.setState({is_active: false})
  }

  enable()
  {
    this.setState({is_active: true})
  }

  render() {
    var message = this.props.message;
    // allowSkip: "false"
    // anim: "line"
    // autoDismiss: "false"
    // id: "14"
    // itemColor: "#666666"
    // position: "bottom"
    // style: "narrative"
    // type: "fullScreen"
    // urlColor: "#000000"
    // urlEnabled: "false"


    var bg = message.bg || message.media;

    // color: "#000000"
    // src: "24_s2_op"
    // type: "video"


    var text = message.text;

    // anim: "typewriter"
    // color: "#FFFFFF"
    // size: "xlarge"
    // style: "regular"

    var bg_type = null;
    var bg_src = null;
    var bg_color = '#000';
    if (bg)
    {
      bg_type = bg._attributes.type;
      bg_src = bg._attributes.src;
      bg_color = bg._attributes.color;
    }
    if (global.DEBUG)
      console.log(this.props.message, bg, text);

    if (!this.state.is_active)
    {
      return null;
    }

    if (this.props.is_expired)
    {
      return null;
    }

    return (
      <TBCBackground onClick={(e) => {
        if (this.props.is_modal)
        {
          e.preventDefault();
          e.stopPropagation();
          this.nextMessage()
        }
      }} bg={bg} is_modal={this.props.is_modal}>
        {
          bg_type === 'image' ? null : (
              <TBCMessage is_overlay
                          is_expired={this.props.is_expired}
                          is_modal={this.props.is_modal}
                          is_fullscreen={this.props.is_fullscreen}
                          message={message} text={text}>
              </TBCMessage>
          )
        }
      </TBCBackground>
    );



  }

}